import { JumpToLink } from "modules/booking/components/JumpToLink";
import { WarningFontIcon } from "modules/booking/components/WarningFontIcon";
import { FunctionComponent } from "react";

import { Link, MessageBar, MessageBarType, Text } from "@bps/fluent-ui";

interface BaseIntervalWarningMessageBarProps {}
export const BaseIntervalWarningMessageBar: FunctionComponent<
  BaseIntervalWarningMessageBarProps
> = () => {
  const defaultLink = (
    <Link
      href="https://kb.bestpracticesoftware.com/bppremier/Orchid/Management/AppointmentBook/AdjustDefaultApptTime.htm?"
      target="_blank"
    >
      default appointment length
    </Link>
  );

  return (
    <MessageBar
      messageBarType={MessageBarType.severeWarning}
      styles={{
        iconContainer: { display: "none" },
        innerText: {
          whiteSpace: "none"
        },
        root: { minHeight: "auto" }
      }}
    >
      <Text variant="small">
        Your Bp Premier {defaultLink} has changed. Please review and update
        impacted{" "}
        <JumpToLink text="Appointment types" jumpTo="appointmentTypes" /> and{" "}
        <JumpToLink text="Providers" jumpTo="providers" /> that have customised
        appointments. Records requiring action are denoted with the icon
      </Text>
      <WarningFontIcon
        iconStyles={{ root: { marginLeft: 4, paddingBottom: 2 } }}
      />
    </MessageBar>
  );
};
